import { addYears } from 'date-fns';
import useLocaleContext from './useLocaleContext.js';

const DATE_MIN = addYears(new Date(), -1);
const DATE_MAX = addYears(new Date(), 1);

function useDateFormats() {
  const { locale } = useLocaleContext();

  function format(date, options) {
    const result = Intl.DateTimeFormat(locale, options).format(date);
    return date > DATE_MIN && date < DATE_MAX ? result.replace(/\W+20\d{2}/, '') : result;
  }
  const dateFormat = Intl.DateTimeFormat(locale, { dateStyle: 'medium' });
  const dateTimeFormat = Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' });
  const timeFormat = Intl.DateTimeFormat(locale, { timeStyle: 'short' });
  const longDateFormat = Intl.DateTimeFormat(locale, { dateStyle: 'long' });
  const dateNoYear = Intl.DateTimeFormat(locale, { month: 'long', day: 'numeric' });
  return { format, dateFormat, dateTimeFormat, timeFormat, longDateFormat, dateNoYear };
}

export default useDateFormats;
